import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';

import { Select, SelectProps, ValidationMessage } from '@xsolla/ui-core';

import { FlexParentBlock } from '../../../styled';
import { FieldInputTitle, FullWideContentBlock } from './style';

type Props = SelectProps & {
  label?: ReactNode;
  extraRight?: ReactNode;
  name: string;
};

const FieldSelect = ({ label, extraRight, errorMessage, name, ...props }: Props): JSX.Element => {
  return (
    <>
      <FieldInputTitle>{label}</FieldInputTitle>
      <FlexParentBlock>
        <FullWideContentBlock extraRight={!!extraRight}>
          <Field name={name}>
            {({ input }) => <Select value={input.value} onChange={input.onChange} {...props} />}
          </Field>
          <ValidationMessage>{errorMessage}</ValidationMessage>
        </FullWideContentBlock>
        {extraRight}
      </FlexParentBlock>
    </>
  );
};

export default FieldSelect;
